import IconCard from "../atoms/IconCard"
import PatternedDiv from "components/PatternedDiv"

export default function IconCardSection({ blok }) {
  return (
    <div>
      <PatternedDiv heading={blok.heading} content={blok.content}>
        <div className="lg:grid-cols-2 grid gap-10 z-10 relative ">
          {blok.icon_cards?.map((card) => (
            <IconCard key={card._uid} blok={card} />
          ))}
        </div>
      </PatternedDiv>
    </div>
  )
}
